<template>
    <div>
        <a-spin :spinning="spinning">
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                    :colon="false"
            >
                <a-form-model-item ref="technical_support_text" label="技术支持" prop="technical_support_text"
                                   :help="formErr.technical_support_text"
                                   :validateStatus='!formErr.technical_support_text||formErr.technical_support_text ==""?"":"error"'>
                    <a-input v-model="form.technical_support_text"
                             @change="(e) => { formErr.technical_support_text='' }"
                             :maxLength="50"
                             placeholder="请输入技术支持文字"
                             @blur="(e) => {  form.technical_support_text = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="technical_support_url" label=" " prop="technical_support_url"
                                   :help="formErr.technical_support_url"
                                   :validateStatus='!formErr.technical_support_url||formErr.technical_support_url ==""?"":"error"'>
                    <a-input v-model="form.technical_support_url"
                             :maxLength="200" placeholder="请输入技术支持链接"
                             @change="changeSupportUrl "
                             @blur="(e) => {  form.technical_support_url = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="google_agent_url" label="谷歌镜像网址" prop="google_agent_url"
                                   :help="formErr.google_agent_url"
                                   :validateStatus='!formErr.google_agent_url||formErr.google_agent_url==""?"":"error"'>
                    <a-input v-model="form.google_agent_url" @change="(e) => { formErr.google_agent_url='' }"
                             :maxLength="200"
                             @blur="(e) => {  form.google_agent_url = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="share" label="share分享代码" prop="share"
                                   :help="formErr.share"
                                   :validateStatus='!formErr.share||formErr.share==""?"":"error"'>
                    <a-textarea :maxLength="2000" :rows="4" v-model="form.share"
                                @change="(e) => { formErr.share='' }"
                                @blur="(e) => {  form.share = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="aggregation_view_1" label="聚合页面句型一" prop="aggregation_view_1" :help="formErr.aggregation_view_1"
                                   :validateStatus='!formErr.aggregation_view_1||formErr.aggregation_view_1==""?"":"error"'>
                    <a-textarea :maxLength="2000" :rows="4" v-model="form.aggregation_view_1" @change="(e) => { formErr.aggregation_view_1='' }" />
<!--                    @blur="(e) => {  form.aggregation_view_1 = e.target.value.trim() }"-->
                </a-form-model-item>
                <a-form-model-item ref="aggregation_view_2" label="聚合页面句型二" prop="aggregation_view_2"
                                   :help="formErr.aggregation_view_2"
                                   :validateStatus='!formErr.aggregation_view_2||formErr.aggregation_view_2==""?"":"error"'>
                    <a-textarea :rows="4" v-model="form.aggregation_view_2" @change="(e) => { formErr.aggregation_view_2='' }"
                                />
<!--                    @blur="(e) => {  form.aggregation_view_2 = e.target.value.trim() }"-->
                </a-form-model-item>
                <a-form-model-item ref="aggregation_view_3" label="聚合页面句型三" prop="aggregation_view_3"
                                   :help="formErr.aggregation_view_3"
                                   :validateStatus='!formErr.aggregation_view_3||formErr.aggregation_view_3==""?"":"error"'>
                    <a-textarea :rows="4" v-model="form.aggregation_view_3" @change="(e) => { formErr.aggregation_view_3='' }" />
<!--                    @blur="(e) => {  form.aggregation_view_3 = e.target.value.trim() }"-->
                </a-form-model-item>
                <a-form-model-item label="订阅号二维码" :help="formErr.subscription_qr_code"
                                   :validateStatus='!formErr.subscription_qr_code||formErr.subscription_qr_code==""?"":"error"'>
                    <a-upload
                            :action="this.$store.state.urlChang"
                            :data="{type:1}"
                            :file-list="form.subscription_qr_code"
                            :headers="headers"
                            @change="(file)=>{handleChange(file,'subscription_qr_code')}"
                            :before-upload="beforeUpload"
                            @preview="handlePreview"
                            list-type="picture-card"
                            name="file"
                    >
                        <div v-if="form.subscription_qr_code.length < 1">
                            <a-icon type="plus"/>
                            <div class="ant-upload-text">Upload</div>
                        </div>
                    </a-upload>
                    <span class="lab">不超过2M的jpeg、jpg、png格式的图片</span>
                    <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                        <img :src="previewImage" alt="example" style="width: 100%"/>
                    </a-modal>

                </a-form-model-item>
                <a-form-model-item label="服务号二维码" :help="formErr.service_qr_code"
                                   :validateStatus='!formErr.service_qr_code||formErr.service_qr_code==""?"":"error"'>
                    <a-upload
                            :action="this.$store.state.urlChang"
                            :data="{type:1}"
                            :file-list="form.service_qr_code"
                            :headers="headers"
                            @change="(file)=>{handleChange(file,'service_qr_code')}"
                            :before-upload="beforeUpload"
                            @preview="handlePreview"
                            list-type="picture-card"
                            name="file"
                    >
                        <div v-if="form.service_qr_code.length < 1">
                            <a-icon type="plus"/>
                            <div class="ant-upload-text">Upload</div>
                        </div>
                    </a-upload>
                    <span class="lab">不超过2M的jpeg、jpg、png格式的图片</span>
                    <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                        <img :src="previewImage" alt="example" style="width: 100%"/>
                    </a-modal>

                </a-form-model-item>
                <a-form-model-item label="手机响呗二维码" :help="formErr.app_qr_code"
                                   :validateStatus='!formErr.app_qr_code||formErr.app_qr_code==""?"":"error"'>
                    <a-upload
                            :action="this.$store.state.urlChang"
                            :data="{type:1}"
                            :file-list="form.app_qr_code"
                            :headers="headers"
                            @change="(file)=>{handleChange(file,'app_qr_code')}"
                            :before-upload="beforeUpload"
                            @preview="handlePreview"
                            list-type="picture-card"
                            name="file"
                    >
                        <div v-if="form.app_qr_code.length < 1">
                            <a-icon type="plus"/>
                            <div class="ant-upload-text">Upload</div>
                        </div>
                    </a-upload>
                    <span class="lab">不超过2M的jpeg、jpg、png格式的图片</span>
                    <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                        <img :src="previewImage" alt="example" style="width: 100%"/>
                    </a-modal>

                </a-form-model-item>

              <a-form-model-item
                  ref="translation_source"
                  label="超管翻译接口"
                  prop="translation_source"
                  :extra="formErr.translation_source"
                  :validateStatus='!formErr.translation_source||formErr.translation_source==""?"":"error"'
              >
                <a-radio-group v-model="form.translation_source"  >
                  <a-radio :value="item.value" v-for="(item, idx) in translation_source_list" :key="idx"> {{item.name}} </a-radio>

                </a-radio-group>
              </a-form-model-item>
                <a-form-model-item label=" ">
                    <a-button type="primary" @click="onSubmit">
                        确认
                    </a-button>
                    <!--                    <a-button style="margin-left: 10px;" @click="resetForm">-->
                    <!--                        -->
                    <!--                    </a-button>-->
                </a-form-model-item>
            </a-form-model>
        </a-spin>
    </div>
</template>

<script>

    import API from "./api"
    import {submitForm, validator,checkUrl} from "../../../utils/utils"

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        name: "index",
        data() {
            let checkUrls=checkUrl
            return {
              translation_source_list:[],
                changetab: 1,
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                previewVisible: false,
                previewImage: "",
                fileList: [],
                spinning: true,
                formErr: {
                    technical_support_text: "",
                    technical_support_url: "",
                    google_agent_url: "",
                    share: "",
                    aggregation_view_1: "",
                    aggregation_view_2: "",
                    aggregation_view_3: "",
                    subscription_qr_code: "",
                    service_qr_code: "",
                    app_qr_code: "",
                  translation_source:''
                },
                labelCol: {span: 4},
                wrapperCol: {span: 10},
                other: '',
                form: {
                    technical_support_text: "",
                    technical_support_url: "",
                    google_agent_url: "",
                    share: "",
                    aggregation_view_1: "",
                    aggregation_view_2: "",
                    aggregation_view_3: "",
                    subscription_qr_code: [],
                    service_qr_code: [],
                    app_qr_code: [],
                  translation_source:''
                },
                imgArr: {
                    subscription_qr_code: "",
                    service_qr_code: "",
                    app_qr_code: "",
                },
                rules: {
                    technical_support_text: [{
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.technical_support_text)
                        }, trigger: "blur"
                    },],
                    technical_support_url: [{validator:(rule, value, callback)=>{checkUrls(rule, value, callback,this.formErr.technical_support_url)}, trigger: "blur"  }, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.technical_support_url)
                        }, trigger: "blur"
                    },],
                    google_agent_url: [{validator:(rule, value, callback)=>{checkUrls(rule, value, callback,this.formErr.google_agent_url)}, trigger: "blur"  },{
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.google_agent_url)
                        }, trigger: "blur"
                    },],
                    share: [{
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.share)
                        }, trigger: "blur"
                    },],
                    aggregation_view_1: [{
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.aggregation_view_1)
                        }, trigger: "blur"
                    },],
                    aggregation_view_2: [{
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.aggregation_view_2)
                        }, trigger: "blur"
                    },],
                    aggregation_view_3: [{
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.aggregation_view_3)
                        }, trigger: "blur"
                    },],
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/UserBackground/InformationSettings"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getFormData()
        },
        methods: {
            changeSupportUrl(){
                this.$refs.ruleForm.clearValidate('technical_support_url', (contentError) => {  })
            },
            getFormData() {
                API.informationSettings.GET_DATA().then(res => {
                  this.translation_source_list= res.data.data.translation_source_list
                    let data = res.data.data.info
                    let {subscription_qr_code, service_qr_code, app_qr_code} = res.data.data.info
                    let fileArr = [{name: "subscription_qr_code", val: subscription_qr_code}, {
                        name: "service_qr_code",
                        val: service_qr_code
                    }, {name: "app_qr_code", val: app_qr_code}]
                    fileArr.map((item, index) => {
                        if (item.val == "") {
                            data[item.name] = []
                        } else {
                            data[item.name] = [
                                {uid: item.val, name: item.val, status: "done", url: item.val ? item.val : ""}
                            ]
                            this.imgArr[item.name] = item.val
                        }
                    })
                    // this.imgArr
                    this.form = data
                    this.spinning = false;
                })

            },
            handleCancel() {
                this.previewVisible = false;
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },

            handleChange(info, type) {
                let {fileList} = info;
                const status = info.file.status;
                if (info.file.removed) {
                    this.imgArr[type] = ""
                    return
                }
                if (status === 'uploading') {
                    this.form[type] = fileList
                }
                if (status === 'done') {
                    this.imgArr[type] = fileList[0].response.data.url
                    getBase64(info.file.originFileObj, imageUrl => {
                    });
                } else if (status === 'error') {
                } else if (status !== 'uploading') {
                    this.form[type] = []
                    this.imgArr[type] = ""
                }
            },
            beforeUpload(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    this.$message.error('只能上传jpeg、jpg，png类型图片!');
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('图片必须小于 2MB!');
                    return false
                }
                return new Promise(function (resolve, reject) {
                    resolve(file)
                })
            },

            // handleChange({fileList}) {
            //     this.fileList = fileList;
            //     this.changetab = 2
            //     this.formErr.site_logo = "";
            //     if (this.fileList.length < 1) {
            //         // this.formErr.logo_thumb = "LOGO不能为空"
            //     }
            // },
            onSubmit() {
                let _this = this;
                let formVal = JSON.parse(JSON.stringify(this.form))
                let {subscription_qr_code, service_qr_code, app_qr_code} = this.imgArr
                formVal.subscription_qr_code = subscription_qr_code
                formVal.service_qr_code = service_qr_code
                formVal.app_qr_code = app_qr_code
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        submitForm(API.informationSettings.SUBMIT_ADD, {...formVal}).then(res => {
                            if (res == true) {
                                this.form = {
                                    technical_support_text: "",
                                    technical_support_url: "",
                                    google_agent_url: "",
                                    share: "",
                                    aggregation_view_1: "",
                                    aggregation_view_2: "",
                                    aggregation_view_3: "",
                                    subscription_qr_code: [],
                                    service_qr_code: [],
                                    app_qr_code: [],
                                },
                                    this.getFormData()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .lab {
        position: absolute;
        top: 8px;
        width: 100%;
        left: 0
    }
</style>
